import { CheckmarkIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { CustomDomainContextMenu } from './CustomDomainContextMenu';
import { DomainItemContainer, DomainItemStatusBadge, DomainItemValue } from './DomainItem';
import { DomainItemProps } from './PendingDomainItem';

export const ActiveDomainItem = ({ label, value, actions }: DomainItemProps) => {
  const translate = useTranslate();

  return (
    <DomainItemContainer>
      <DomainItemStatusBadge
        label={translate('label.active')}
        className='bg-green-haze text-white'
        icon={<CheckmarkIcon color='white' />}
      />
      <DomainItemValue label={label} value={value} />
      <div className='ml-auto'>
        <CustomDomainContextMenu actions={actions} />
      </div>
    </DomainItemContainer>
  );
};
